module.exports = __webpack_public_path__ + "img/shop.41e064e7.svg";